import { setAttr } from '../../scripts/utils/setAttr';

export const activateSmartApartmentTab = () => {
  const tabControls = document.querySelectorAll(
    '[data-smart-apartment-tab-button]'
  );

  tabControls.forEach((tabControl) => {
    tabControl.addEventListener('click', () => {
      const key = tabControl.getAttribute('data-active-tab');

      setAttr(key, 'data-active', '[data-smart-apartment]', tabControl);
    });
  });
};
